<template>
  <div>
    <div class="page flex-col">
    <div class="box_1 flex-col">
      <!-- 头部导航组件 -->
      <HeaderNav />
      
      <div class="product-detail-content flex-col">
        <div class="product-detail-header flex-col" v-if="productDetail">
          <h1 class="product-detail-title">{{ productDetail.title }}</h1>
          <div class="product-detail-meta flex-row">
            <span class="product-detail-price">参考价：¥{{ formatPrice(productDetail.price) }}</span>
            <span class="product-detail-date">{{ formatDate(productDetail.created_at) }}</span>
          </div>
        </div>
        
        <div class="product-detail-image" v-if="productDetail && productDetail.cover">
          <img :src="productDetail.cover" :alt="productDetail.title" />
        </div>
        
        <div class="product-detail-body flex-col" v-if="productDetail">
          <div 
            class="product-detail-html"
            v-html="productDetail.description"
          ></div>
        </div>
        
        <div class="product-detail-loading flex-col" v-if="loading">
          <p>加载中...</p>
        </div>
        
        <div class="product-detail-empty flex-col" v-if="!loading && !productDetail">
          <p>产品不存在</p>
        </div>
        
        <div class="product-detail-order flex-col" v-if="productDetail">
          <div class="order-select-wrapper flex-row">
            <span class="order-label">逝者：</span>
            <select 
              v-model="selectedAwayId" 
              @change="handleAwayChange"
              class="away-select"
            >
            <option value="" disabled>
              {{ awayList && awayList.length > 0 ? '请选择逝者' : '请在个人中心添加逝者' }}
            </option>
              <option 
                v-for="item in awayList" 
                :key="item.id" 
                :value="item.id"
              >
                {{ item.name || '未命名' }}
              </option>
            </select>
          </div>
        </div>
        
        <div class="product-detail-actions flex-row">
          <van-button 
            type="default" 
            @click="goBack"
            class="back-btn"
          >
            返回列表
          </van-button>
          <van-button 
            type="primary" 
            @click="handleCreateOrder"
            :loading="submitting"
            class="order-btn"
            v-if="productDetail"
          >
            立即购买
          </van-button>
        </div>
      </div>

      <!-- 支付弹窗（二维码 + 轮询支付状态） -->
      <van-popup
        v-model="payPopupVisible"
        class="pay-popup"
        :close-on-click-overlay="false"
        @closed="cleanupPayFlow"
      >
        <div class="pay-popup-inner">
          <div class="pay-title">请扫码支付</div>
          <div class="pay-order-no" v-if="payOrderNo">订单号：{{ payOrderNo }}</div>
          <div class="pay-qr-wrapper">
            <img v-if="payQrDataUrl" class="pay-qr-img" :src="payQrDataUrl" alt="支付二维码" />
            <div v-else class="pay-qr-loading">二维码生成中...</div>
          </div>
          <div class="pay-countdown">有效期：{{ payRemainingText }}</div>
          <div class="pay-actions">
            <van-button size="small" type="default" @click="closePayPopup">取消</van-button>
          </div>
        </div>
      </van-popup>
      
      <!-- 底部组件 -->
    </div>
    </div>
    <!-- 联系我们部分 - 独立整体 -->
    <ContactUsSection />
  </div>
</template>

<script>
import HeaderNav from '@/components/HeaderNav.vue';
import ContactUsSection from '@/components/ContactUsSection.vue';
import { getProduct, getAwayList, createOrder, goPay, getOrderDetail } from '@/api/home';
import { isLoggedIn } from '@/api/auth';
import { Toast } from 'vant';
import QRCode from 'qrcode';

export default {
  name: 'ProductDetail',
  components: {
    HeaderNav,
    ContactUsSection
  },
  data() {
    return {
      productDetail: null,
      loading: false,
      awayList: [], // 逝者列表
      selectedAwayId: '', // 选中的逝者ID
      submitting: false, // 提交中状态

      // 支付弹窗/轮询
      payPopupVisible: false,
      payOrderNo: '',
      payQrDataUrl: '',
      payDeadlineTs: 0,
      payRemainingSec: 0,
      payCountdownTimer: null,
      payPollTimer: null
    };
  },
  mounted() {
    const productId = this.$route.query.product_id || this.$route.params.id;
    if (productId) {
      this.fetchProductDetail(productId);
    }
    this.fetchAwayList();
  },
  beforeDestroy() {
    this.cleanupPayFlow();
  },
  computed: {
    payRemainingText() {
      const sec = Math.max(0, Number(this.payRemainingSec) || 0);
      const mm = Math.floor(sec / 60);
      const ss = sec % 60;
      return `${mm}:${ss < 10 ? '0' + ss : ss}`;
    }
  },
  methods: {
    // 获取产品详情
    async fetchProductDetail(productId) {
      this.loading = true;
      try {
        const res = await getProduct(productId);
        if (res.code === 0 && res.data && res.data.row) {
          this.productDetail = res.data.row;
        } else {
          Toast.fail('产品不存在');
        }
      } catch (error) {
        console.error('获取产品详情失败:', error);
        Toast.fail('获取产品详情失败');
      } finally {
        this.loading = false;
      }
    },
    // 格式化价格
    formatPrice(price) {
      if (!price) return '0.00';
      const num = parseFloat(price);
      return num.toFixed(2);
    },
    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`;
    },
    // 返回列表
    goBack() {
      this.$router.go(-1);
    },
    // 获取逝者列表
    async fetchAwayList() {
      try {
        const res = await getAwayList();
        if (res.code === 0 && res.data && res.data.list) {
          this.awayList = res.data.list;
        }
      } catch (error) {
        console.error('获取逝者列表失败:', error);
        this.awayList = [];
      }
    },
    // 处理逝者选择变化
    handleAwayChange(event) {
      const value = event.target.value;
      this.selectedAwayId = value;
    },
    // 处理立即购买
    async handleCreateOrder() {
      // 未登录时直接提示
      if (!isLoggedIn()) {
        Toast.fail('您还没有登陆，请点击页面右上角登陆或注册。');
        return;
      }

      // 验证是否选择了逝者
      if (!this.selectedAwayId) {
        if (!this.awayList || this.awayList.length === 0) {
          Toast.fail('请在个人中心添加逝者');
        } else {
          Toast.fail('请选择逝者');
        }
        return;
      }
      
      // 验证产品是否存在
      if (!this.productDetail || !this.productDetail.id) {
        Toast.fail('产品信息错误');
        return;
      }
      
      // 防止重复提交
      if (this.submitting) {
        return;
      }
      
      this.submitting = true;
      
      try {
        const res = await createOrder({
          product_id: this.productDetail.id.toString(),
          away_id: this.selectedAwayId.toString()
        });
        
        if (res.code === 0) {
          const orderNo = res?.data?.order_no;
          if (!orderNo) {
            Toast.fail('下单成功但未返回订单号');
            return;
          }
          await this.startPayFlow(orderNo);
        } else {
          Toast.fail(res.msg || '下单失败，请重试');
        }
      } catch (error) {
        console.error('下单失败:', error);
        Toast.fail('下单失败，请重试');
      } finally {
        this.submitting = false;
      }
    },
    async startPayFlow(orderNo) {
      this.cleanupPayFlow();

      this.payOrderNo = orderNo;
      this.payPopupVisible = true;
      this.payQrDataUrl = '';
      this.payDeadlineTs = Date.now() + 5 * 60 * 1000; // 5分钟
      this.payRemainingSec = 5 * 60;

      // 请求支付URL
      let payUrl = '';
      try {
        const payRes = await goPay({ order_no: orderNo });
        payUrl = payRes?.data?.url || '';
      } catch (e) {
        console.error('goPay失败:', e);
        Toast.fail('拉取支付信息失败');
        this.closePayPopup();
        return;
      }

      if (!payUrl) {
        Toast.fail('支付链接为空');
        this.closePayPopup();
        return;
      }

      // 生成二维码
      try {
        this.payQrDataUrl = await QRCode.toDataURL(payUrl, {
          errorCorrectionLevel: 'M',
          margin: 1,
          width: 260
        });
      } catch (e) {
        console.error('二维码生成失败:', e);
        Toast.fail('二维码生成失败');
        this.closePayPopup();
        return;
      }

      // 倒计时（超时自动关闭）
      this.payCountdownTimer = setInterval(() => {
        const remainMs = this.payDeadlineTs - Date.now();
        const remainSec = Math.ceil(remainMs / 1000);
        this.payRemainingSec = Math.max(0, remainSec);
        if (remainMs <= 0) {
          Toast.fail('支付超时');
          this.closePayPopup();
        }
      }, 1000);

      const pollOnce = async () => {
        if (!this.payPopupVisible || !this.payOrderNo) return;
        if (Date.now() >= this.payDeadlineTs) return;
        try {
          const detailRes = await getOrderDetail(this.payOrderNo);
          const payStatus = detailRes?.data?.pay_status;
          if (String(payStatus) === '1') {
            Toast.success('支付成功');
            this.closePayPopup();
          }
        } catch (e) {
          console.warn('getOrderDetail轮询失败:', e);
        }
      };

      await pollOnce();
      this.payPollTimer = setInterval(pollOnce, 3000);
    },
    closePayPopup() {
      this.payPopupVisible = false;
      this.cleanupPayFlow();
    },
    cleanupPayFlow() {
      if (this.payCountdownTimer) {
        clearInterval(this.payCountdownTimer);
        this.payCountdownTimer = null;
      }
      if (this.payPollTimer) {
        clearInterval(this.payPollTimer);
        this.payPollTimer = null;
      }
    }
  }
};
</script>

<style scoped>
.page {
  position: relative;
  width: 1920px;
  height: auto;
  min-height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
}

.box_1 {
  background-color: rgba(255, 255, 255, 1);
  position: relative;
  width: 1920px;
  min-height: 100vh;
}

.product-detail-content {
  width: 1200px;
  margin: 150px auto 0;
  padding: 40px 0;
}

.product-detail-header {
  margin-bottom: 40px;
  padding-bottom: 30px;
  border-bottom: 2px solid rgba(0, 149, 151, 0.2);
}

.product-detail-title {
  font-size: 32px;
  font-weight: bold;
  color: #333;
  margin: 0 0 20px 0;
  line-height: 1.4;
}

.product-detail-meta {
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
}

.product-detail-price {
  font-size: 24px;
  font-weight: bold;
  color: rgba(169, 10, 6, 1);
}

.product-detail-date {
  font-size: 14px;
  color: #999;
}

.product-detail-image {
  width: 100%;
  margin-bottom: 40px;
  text-align: center;
}

.product-detail-image img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.product-detail-body {
  margin-bottom: 40px;
  min-height: 200px;
}

.product-detail-html {
  font-size: 16px;
  line-height: 1.8;
  color: #333;
}

.product-detail-html >>> p {
  margin: 0 0 20px 0;
}

.product-detail-html >>> img {
  max-width: 100%;
  height: auto;
  margin: 20px 0;
}

.product-detail-loading,
.product-detail-empty {
  align-items: center;
  justify-content: center;
  padding: 100px 0;
  color: #999;
  font-size: 16px;
}

.product-detail-order {
  margin-top: 40px;
  padding: 30px;
  background-color: #f9f9f9;
  border-radius: 8px;
  margin-bottom: 20px;
}

.order-select-wrapper {
  align-items: center;
  gap: 15px;
}

.order-label {
  font-size: 16px;
  color: #333;
  font-weight: 500;
  white-space: nowrap;
}

.away-select {
  flex: 1;
  max-width: 400px;
  height: 42px;
  background-color: rgba(255, 255, 255, 1);
  border: 1px solid rgba(222, 222, 222, 1);
  border-radius: 4px;
  padding: 0 12px;
  font-size: 14px;
  color: rgba(92, 92, 92, 1);
  cursor: pointer;
  outline: none;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%235c5c5c' d='M6 8L0 0h12z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 12px 8px;
  padding-right: 32px;
  transition: all 0.3s ease;
}

.away-select:hover {
  border-color: rgba(0, 149, 151, 0.5);
  box-shadow: 0 2px 8px rgba(0, 149, 151, 0.15);
}

.away-select:focus {
  border-color: rgba(0, 149, 151, 1);
  box-shadow: 0 2px 8px rgba(0, 149, 151, 0.2);
}

.product-detail-actions {
  justify-content: center;
  gap: 20px;
  margin-top: 40px;
  padding-top: 40px;
  border-top: 1px solid rgba(0, 149, 151, 0.1);
}

.pay-popup {
  width: 340px;
  border-radius: 10px;
}

.pay-popup-inner {
  padding: 18px 16px 14px;
}

.pay-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  text-align: center;
}

.pay-order-no {
  margin-top: 8px;
  font-size: 12px;
  color: #666;
  text-align: center;
  word-break: break-all;
}

.pay-qr-wrapper {
  margin: 14px auto 10px;
  width: 260px;
  height: 260px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 8px;
}

.pay-qr-img {
  width: 260px;
  height: 260px;
  display: block;
}

.pay-qr-loading {
  font-size: 13px;
  color: #999;
}

.pay-countdown {
  font-size: 13px;
  color: #666;
  text-align: center;
}

.pay-actions {
  margin-top: 14px;
  display: flex;
  justify-content: center;
}

.back-btn {
  padding: 10px 40px;
  color: rgba(0, 149, 151, 1);
  border-color: rgba(0, 149, 151, 1);
}

.order-btn {
  padding: 10px 40px;
  background-color: rgba(0, 149, 151, 1);
  border-color: rgba(0, 149, 151, 1);
}

.footer-wrapper {
  margin: 80px auto 0;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .page {
    width: 100%;
  }

  .box_1 {
    width: 100%;
  }

  .product-detail-content {
    width: 100%;
    padding: 20px;
    margin-top: 100px;
  }

  .product-detail-title {
    font-size: 24px;
  }

  .product-detail-price {
    font-size: 20px;
  }
}
</style>

